<template>
  <div v-loading="optLoading" class="view-contanier">
    <div class="opt">
      <!-- <div v-permissson="'add'" class="btn" @click="add">
        <svg-icon className="icon" iconClass="add" />新增
      </div>
      <div v-permissson="'add'" class="btn" @click="add">
        <svg-icon className="icon" iconClass="add" />新增
      </div> -->
      <div v-permissson="'derive'" class="btn1 flex_c_c" @click="derive">
        <img src="@/assets/images/const/derive.png" alt="导出" />
        导出
      </div>
      <div v-permissson="'add'" class="btn flex_c_c" @click="add">
        <img src="@/assets/images/const/add.png" />
        新增
      </div>
      <BaseFilter :isActive="isActive" :width="504" @sendFilter="sendFilter" @reset="reset">
        <div class="filter">
          <el-form ref="form" :model="filterList" label-width="104px">
            <el-form-item label="费用名称/代码">
              <el-input
                v-model="filterList.search"
                placeholder="请输入费用名称/代码"
                style="width:320px;"
              ></el-input>
            </el-form-item>
            <el-form-item label="费用大类">
              <el-select
                v-model="filterList.feeTypeId"
                style="width: 320px"
                placeholder="请选择费用大类"
              >
                <el-option
                  v-for="item in feeTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="状态">
              <el-select
                v-model="filterList.isActived"
                placeholder="请选择状态"
                style="width:320px;"
              >
                <el-option
                  v-for="item in activeOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </BaseFilter>
    </div>
    <div class="data">
      <BaseTable
        v-if="height !== 0"
        :height="height"
        :tableData="tableData"
        :pageIndex="pagerConfig.pageIndex"
        :pageSize="pagerConfig.pageSize"
        :pageSizes="[20, 30, 50, 100]"
        :loading="loading"
        :isPager="true"
        :isEmptyBorder="true"
        @handlePageChange="handlePageChange"
        @sortChange="sortChange"
      >
        <template slot="name" slot-scope="row">
          <div>
            {{ row.scope.name }}
            <img
              class="edit_name"
              src="@/assets/images/const/edit.png"
              @click="edit(row.scope)"
            />
          </div>
        </template>
        <template slot="classification" slot-scope="row">
          <div v-if="row.scope.classification === 0">订单费用</div>
          <div v-else-if="row.scope.classification === 1">提单费用</div>
          <div v-else-if="row.scope.classification === 2">杂费</div>
          <div v-else-if="row.scope.classification === 3">其他业务</div>
        </template>
        <template slot="isMondary" slot-scope="row">
          <div :class="row.scope.isMondary ? '' : 'grey'">{{ row.scope.isMondary ? "是" : "否" }}</div>
        </template>
        <template slot="isSendWay" slot-scope="row">
          <div :class="row.scope.isSendWay ? '' : 'grey'">{{ row.scope.isSendWay ? "是" : "否" }}</div>
        </template>
        <template slot="isActived" slot-scope="row">
          <div class="typebox">
            <div :class="row.scope.isActived ? 'bod' : 'bod red'"></div>
            <div>{{ row.scope.isActived ? "启用" : "停用" }}</div>
          </div>
        </template>
        <template slot="opt" slot-scope="row">

          <el-popover
              :ref="`popover${row.scope.id}`"
            placement="bottom-start"
            popper-class="pop-table-opt"
            width="114"
            trigger="click"
          >
            <div class="table-opt">
              <span
                class="opt-item"
                @click="changeStatus(row.scope)"
              >{{ !row.scope.isActived ? "启用" : "停用" }}</span
              >
              <span
                v-if="!row.scope.isUsed"
                v-permissson="'delete'"
                class="opt-item"
                @click="deleteRow(row.scope)"
              >删除</span
              >
            </div>
            <img
              slot="reference"
              style="margin-left: -14px"
              src="@/assets/images/table/opt.png"
            />
          </el-popover>
          <!-- <div class="tableopt">
            <div>
              <el-switch
                v-model="row.scope.isActived"
                v-permissson="'able'"
                active-color=" rgb(18,88,188)"
                inactive-color="#CDCDCD"
                :disabled="row.scope.isMondary"
                @change="changeStatus(row.scope)"
              >
              </el-switch
              ><span
                class="status"
                :style="{
                  color: row.scope.isActived ? ' rgb(18,88,188)' : '#999999',
                }"
              >{{ row.scope.isActived ? "启用" : "停用" }}</span
              >
            </div>
            <span v-if="!row.scope.isUsed" v-permissson="'delete'" style="cursor: pointer" @click="deleteRow(row.scope)">删除</span>
          </div> -->
        </template>
      </BaseTable>
    </div>
    <add-fee-dialog :dialogFormVisible="dialogFormVisible" @ok="ok" @cancel="cancel"></add-fee-dialog>
    <EditFeeNameDialog
      :dialogVisible="dialogFormVisible1"
      :editData="editData"
      @cancel="cancel"
      @ok="ok"
    ></EditFeeNameDialog>
  </div>
</template>

<script>
const BaseTable = () => import('@/components/table/BaseTable')
const BaseFilter = () => import('@/components/filter/BaseFilter')

import { getFeeNamePageList, switchFeeName, deleteFeeName, getFeeTypeList } from '@/api/fee'
import AddFeeDialog from './components/AddFeeDialog.vue'
import EditFeeNameDialog from './components/EditFeeNameDialog.vue'
import { derive } from '@/utils/common'
import { myMixins } from '@/mixins'
import config from '@/utils/config'
export default {
  name: 'FeeCode',
  components: {
    BaseTable,
    BaseFilter,
    AddFeeDialog,
    EditFeeNameDialog
  },
  mixins: [myMixins],
  data() {
     return {
      config,
      tableData: {
        fileds: [{
            filed: 'opt',
            label: '',
            width: '50px',
            isCustom: true,
            fixed: 'left'
          },
          {
            filed: 'name',
            label: '费用细类名称',
            width: '220',
            isSort: true, // 是否支持过滤
            align: 'left',
            fixed: 'left', // 是否固定 true, left, right
            isCustom: true // 是否自定义列显示
          },
          {
            filed: 'code',
            label: '费用细类代码',
            align: 'left',
            width: '160',
            isSort: true
          },
          {
            filed: 'feeTypeName',
            align: 'left',
            label: '费用大类名称',
            width: '160',
            isSort: true
          },
          {
            filed: 'feeTypeCode',
            label: '费用大类代码',
            align: 'left',
            width: '160',
            isSort: true
          },
          {
            filed: 'arUnit',
            label: '应收单位',
            width: '80',
            formatter: (row) => {
              const unit = config.feeNameUnitTypeOptions.find(a => row.arUnit === a.value)?.label
              return row.arUnit !== null ? unit : row.arUnit
            }
          },
          {
            filed: 'apUnit',
            label: '应付单位',
            width: '80',
            formatter: (row) => {
              const unit = config.feeNameUnitTypeOptions.find(a => row.apUnit === a.value)?.label
              return row.apUnit !== null ? unit : row.apUnit
            }
          },
          {
            filed: 'expenseQuotaMin',
            label: '费用限额',
            align: 'left',
            width: '160',
            formatter: (row) => {
              if (row.expenseQuotaMin !== null && row.expenseQuotaMax !== null) {
                return row.expenseQuotaMin + '-' + row.expenseQuotaMax
              } else {
                return '0-0'
              }
            }
          },
          {
            filed: 'classification',
            label: '费用归类',
            align: 'left',
            width: '140',
            isCustom: true
          },
          {
            filed: 'isMondary',
            label: '系统预设',
            width: '120',
            align: 'left',
            isCustom: true
          },
          {
            filed: 'isSendWay',
            label: '选择派送方式',
            align: 'left',
            width: '120',
            isCustom: true
          },
          {
            filed: 'unit',
            label: '计算维度',
            align: 'left',
            width: '120',
            formatter: (row) => {
              return config.unitOption.find(a => a.value === row.unit)?.label
            }
          },
          {
            filed: 'description',
            label: '费用介绍',
            align: 'left',
            width: '286'
          },
          {
            filed: 'isActived',
            label: '状态',
            width: '120',
            align: 'left',
            isCustom: true,
            isSort: true
          },
          {
            filed: 'updatedName',
            label: '修改人',
            align: 'left',
            width: '120'
          },
          {
            filed: 'updatedOn',
            label: '修改时间',
            width: '150',
            align: 'left',
            formatter: (row) =>
              row.updatedOn ? row.updatedOn.slice(0, row.updatedOn.length - 3) : '',
            isSort: true
          },
          {
            filed: 'createdName',
            label: '创建人',
            align: 'left',
            width: '120'
          },
          {
            filed: 'createdOn',
            label: '创建时间',
            width: '150',
            align: 'left',
            formatter: (row) =>
              row.createdOn ? row.createdOn.slice(0, row.createdOn.length - 3) : '',
            isSort: true
          }
        ],
        columns: [],
        total: 0
      },
      loading: false,
      pagerConfig: {
        pageIndex: 1,
        pageSize: 20
      },
      height: 0,
      filterList: {
        search: '',
        isActived: '',
        feeTypeId: ''
      },
      isActive: false,
      dialogFormVisible: false,
      dialogFormVisible1: false,
      editData: {},
      drawer: false,
      drawer1: false,
      activeOption: [
        {
          value: true,
          label: '启用'
        },
        {
          value: false,
          label: '停用'
        }
      ],
      orderObj: {},
      feeTypeOptions: []
    }
  },
  created() {
    this.initList()
    this.getFeeTypeList()
  },
  mounted() {
    this.height = document.querySelector('.data').offsetHeight - 43
  },
  methods: {
    ok() {
      this.cancel()
      this.pagerConfig = {
        pageIndex: 1,
        pageSize: 20
      }
      this.getList({
        pageIndex: 1,
        pageSize: 20
      })
    },
    add() {
      this.dialogFormVisible = true
    },
    cancel() {
      this.editData = {}
      this.dialogFormVisible = false
      this.dialogFormVisible1 = false
    },
    handlePageChange(pager) {
      this.pagerConfig = {
        ...this.pagerConfig,
        ...pager
      }
      const params = {
        ...this.pagerConfig,
        ...pager
      }
      this.getList(params)
    },
    sortChange(orderObj) {
      if (orderObj.order) {
        this.orderObj = {
          sortField: orderObj.prop,
          sortBy: orderObj.order === 'asc' ? 0 : 1
        }
      } else {
        this.orderObj = {}
      }
      this.getList(this.pagerConfig)
    },
    getList(params) {
      this.loading = true
      try {
        params = {
          ...params,
          queryParam: {
            ...this.orderObj,
            ...this.formatFilter(),
            isVisible: true
          }
        }
        getFeeNamePageList(params).then((res) => {
          if (res.success) {
            this.loading = false
            this.tableData.columns = res.data.list
            this.tableData.total = res.data.total
          } else {
            this.loading = false
            this.$message.error(res.errorMessage)
          }
        })
      } catch (error) {
        this.loading = false
        console.error(error)
      }
    },
    initList() {
      this.pagerConfig = {
        pageIndex: 1,
        pageSize: 20
      }
      this.getList({
        pageIndex: 1,
        pageSize: 20
      })
    },
    async getFeeTypeList() {
      try {
        const res = await getFeeTypeList()
        if (res.success) {
          const arr = []
          res.data &&
            res.data.map((item) => {
              arr.push({
                value: item.id,
                label: item.name
              })
            })
          this.feeTypeOptions = arr
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.error(error)
      }
    },
    formatFilter() {
      return {
        feeTypeId:
          this.filterList.feeTypeId !== ''
            ? this.filterList.feeTypeId
            : undefined,
        search:
          this.filterList.search !== ''
            ? this.filterList.search
            : undefined,
        isActived:
          this.filterList.isActived !== ''
            ? this.filterList.isActived
            : undefined
      }
    },
    sendFilter() {
      if (
        this.filterList.search !== '' ||
        this.filterList.isActived !== '' ||
        this.filterList.feeTypeId !== ''
      ) {
        this.isActive = true
      } else {
        this.isActive = false
      }
      this.pagerConfig = {
        pageIndex: 1,
        pageSize: 20
      }
      this.getList({
        pageIndex: 1,
        pageSize: 20
      })
    },
    reset() {
      this.filterList = {
        search: '',
        isActived: '',
        feeTypeId: ''
      }
      this.isActive = false
    },
    changeStatus(row) {
      if (row.isMondary) {
        this.$message.error('系统预设不可操作')
        return
      }
      switchFeeName({ id: row.id }).then(res => {
        if (res.success) {
          this.$message.success('修改成功')
          this.getList(this.pagerConfig)
        } else {
          this.$message.error(res.errorMessage)
        }
      })
    },
    deleteRow(row) {
      if (row.isMondary) {
        this.$message.error('系统预设不可操作')
        return
      }
      this.$confirm('此操作将删除该费用细类, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          deleteFeeName({
            feeNameId: row.id
          }).then((res) => {
            this.loading = false
            if (res.success) {
              this.$message.success('删除成功')
              this.initList()
            } else {
              this.$message.error(res.errorMessage)
            }
          })
        })
        .catch(() => {})
    },
    edit(row) {
      this.editData = row
      this.dialogFormVisible1 = true
    },
    async derive() {
      this.optLoading = true
      const params = {
        ...this.pagerConfig,
          queryParam: {
            ...this.filterList,
            isVisible: true
          }
      }
      await derive('Fee/exportFeeNameList', 'post', params)
      this.optLoading = false
    }
  }
}
</script>

<style lang="less" scoped>
.view-contanier {
  width: 100%;
  padding: 0 10px;
  height: 100%;
  background: #fff;
  box-sizing: border-box;
  overflow: auto;
  .opt {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .btn {
    width: 80px;
    height: 30px;
    background:  rgb(18,88,188);
    border-radius: 4px;
    border: 1px solid #eeeeee;
    opacity: 1;
    font-size: 14px;
    font-weight: 400;
    color: #ffffff;
    line-height: 30px;
    text-align: center;
    cursor: pointer;
    margin-right: 10px;
  }
  .btn1 {
    width: 80px;
    height: 28px;
    background: #ffffff;
    color:  rgb(18,88,188);
    border-radius: 4px;
    border: 1px solid  rgb(18,88,188);
    opacity: 1;
    font-size: 14px;
    font-weight: 400;
    line-height: 28px;
    text-align: center;
    cursor: pointer;
    margin-right: 10px;
  }
  .icon {
    font-size: 20px;
    vertical-align: text-top;
  }
  .data {
    width: 100%;
    height: calc(100% - 50px);
    & .fTable {
      border-top: 1px solid #ebeef5;
      box-sizing: border-box;
    }
    .edit_name {
      cursor: pointer;
    }
  }
  .circle {
    width: 6px;
    height: 6px;
    opacity: 1;
    display: inline-block;
    border-radius: 50%;
    margin-right: 6px;
  }
  .tableopt {
    display: flex;
    justify-content: left;
    align-items: center;
    margin-left: 20px;
    span {
      margin-right: 20px;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color:  rgb(18,88,188);
      cursor: pointer;
    }
  }
  .grey {
    color: #CDCDCD;
  }
  .typebox {
    display: flex;
    justify-content: center;
    align-items: center;
    .bod {
      width: 6px;
      height: 6px;
      background: #35ba83;
      opacity: 1;
      border-radius: 50%;
      margin-right: 5px;
    }
    .red {
      width: 6px;
      height: 6px;
      background: #fe453d;
      opacity: 1;
    }
  }

  .status {
    width: 28px;
    height: 19px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color:  rgb(18,88,188);
    line-height: 20px;
    margin-left: 5px;
    margin-right: 31px;
  }
  .table-opt:deep(.el-button) {
    padding: 0;
  }
}
</style>
